import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { memberFcdetails, mergeFcDetails } from '../../services/raintree/interfaces/merge_data_FcSl.interface';

@Injectable({
  providedIn: 'root'
})
export class SlMergeShareService {
  memberDpDetails = signal<serialNumberMerge|null>(null);
  meberFcDetails = signal<fcCodeMerge|null>(null);
  comment = signal<string>('');
  toggleType = signal<any>(null);
  

  constructor() { }

  onToggoleChange(type:string) {
    this.toggleType.set(type);
  }
  
}

export interface serialNumberMerge {
  primaryKey:  number;
  addedMemberData: any[];
  mergeDetails: any[];
}

export interface fcCodeMerge {
  primaryFc:  string;
  addedMemberFcData: memberFcdetails[];
  prevFCMergedata: mergeFcDetails[];
}